import React from 'react';

import GridItem from 'components/Grid/GridItem';

//iconos material
import { Chip, makeStyles, Paper } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import { formatDate } from 'hooks/Pipe';
import { useModal } from 'hooks/useModal';
import LogsModal from 'components/Tvendo/Common/LogsModal';
import RegularButton from 'components/CustomButtons/Button';
import LogsFrozenFor from '../Modal/LogsFrozenFor';
import { Book } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    '& h6': {
      fontSize: 13,
      color: theme.palette.text.secondary,
      margin: 0
    },
    '& h5': {
      fontSize: 15,
      fontWeight: 400,
      margin: 0,
      marginBottom: 10
    },
    marginBottom: '15px'
  }
}));

export default function Read(props) {
  const classes = useStyles();

  const bPartner = props.bPartner; //datos de socio
  const [model, setOpen] = useModal();
  const [modelFrozenFor, setFrozenForOpen] = useModal();

  return (
    <GridContainer>
      <LogsModal
        model={model}
        setOpen={setOpen}
        logName="base_business_partners"
        subjectId={bPartner.id}
      />

      <LogsFrozenFor
        model={modelFrozenFor}
        setOpen={setFrozenForOpen}
        businessPartner={bPartner}
      />

      {bPartner.U_SYP_BPTP === 'TPN' ? (
        <GridItem xs={12} sm={6} md={6} lg={4}>
          <Paper className={classes.paper}>
            <h6>Tipo documento</h6>
            <h5>{bPartner.base_document_type_description}</h5>
            <h6>Primer Nombre</h6>
            <h5> {bPartner.U_SYP_BPNO}</h5>
            <h6>Segundo Nombre</h6>
            <h5>{bPartner.U_SYP_BPN2}</h5>
            <h6>Apellido Paterno</h6>
            <h5>{bPartner.U_SYP_BPAP}</h5>
            <h6>Apellido Materno</h6>
            <h5>{bPartner.U_SYP_BPAM}</h5>
            <h6>Correo</h6>
            <h5>{bPartner.E_Mail}</h5>
            <h6>Celular</h6>
            <h5>{bPartner.Cellular}</h5>
            <h6>Teléfono</h6>
            <h5>{bPartner.Phone1}</h5>
          </Paper>
        </GridItem>
      ) : (
        ''
      )}

      <GridItem xs={12} sm={6} md={6} lg={4}>
        <Paper className={classes.paper}>
          <h6>Código</h6>
          <h5>{bPartner.CardCode}</h5>
          <h6>Documento ({bPartner.base_document_type_description})</h6>
          <h5>{bPartner.LicTradNum}</h5>
          <h6>Nombre Comercial</h6>
          <h5>{bPartner.CardFName}</h5>
          <h6>Nombre Socio Negocio</h6>
          <h5>{bPartner.CardName}</h5>
          {bPartner.CardType === 'S' && (
            <>
              <h6>Dirección</h6>
              <h5>{bPartner.Address}</h5>
            </>
          )}
          {/* <h6>Código Socio Relacionado</h6>
          <h5>{bPartner.CardCode_relationed}</h5> */}
          <h6>Validación - Revisión</h6>
          <h5>{bPartner.validated_at}</h5>
          <h6>Socio es empleado</h6>
          <h5>{bPartner.QryGroup5 === 'Y' ? 'Sí' : bPartner.QryGroup5 === 'N' ? 'No' : '-'}</h5>
          {bPartner.CardType === 'C' ? (
            <>
              <h6>Aplica interés en órdenes al crédito</h6>
              <h5>{bPartner.QryGroup4 === 'Y' ? 'Sí' : bPartner.QryGroup4 === 'N' ? 'No' : '-'}</h5>

              <h6>Clientes varios</h6>
              <h5>{bPartner.QryGroup7 === 'Y' ? 'Sí' : bPartner.QryGroup7 === 'N' ? 'No' : '-'}</h5>

              <h6>Facturación concepto proveedores</h6>
              <h5>{bPartner.QryGroup8 === 'Y' ? 'Sí' : bPartner.QryGroup8 === 'N' ? 'No' : '-'}</h5>
            </>
          ) : (
            <>
              <h6>Proveedor de mercadería</h6>
              <h5>{bPartner.QryGroup1 === 'Y' ? 'Sí' : bPartner.QryGroup1 === 'N' ? 'No' : '-'}</h5>
              {bPartner.QryGroup1 === 'Y' ? (
                <>
                  <h6>Prefijo</h6>
                  <h5>{bPartner.prefix}</h5>
                  <h6>Reconocimiento Desc.</h6>
                  <h5>
                    {bPartner.QryGroup2 === 'Y' ? 'Sí' : bPartner.QryGroup2 === 'N' ? 'No' : '-'}
                  </h5>
                </>
              ) : undefined}

              <h6>Proveedor de vehículo</h6>
              <h5>{bPartner.QryGroup3 === 'Y' ? 'Sí' : bPartner.QryGroup3 === 'N' ? 'No' : '-'}</h5>

              <h6>Proveedores varios</h6>
              <h5>{bPartner.QryGroup7 === 'Y' ? 'Sí' : bPartner.QryGroup7 === 'N' ? 'No' : '-'}</h5>
            </>
          )}
          <h6>Recibo por honorarios</h6>
          <h5>{bPartner.QryGroup6 === 'Y' ? 'Sí' : bPartner.QryGroup6 === 'N' ? 'No' : '-'}</h5>

          <h6>Proveedor Principal</h6>
          <h5>{bPartner.QryGroup9 === 'Y' ? 'Sí' : bPartner.QryGroup9 === 'N' ? 'No' : '-'}</h5>
        </Paper>
      </GridItem>
      <GridItem xs={12} sm={6} md={6} lg={4}>
        <Paper className={classes.paper}>
          <h6>Grupo Socio Negocio</h6>
          <h5>{bPartner.GroupCode}</h5>
          <h6>Tipo Moneda</h6>
          <h5>{bPartner.Currency === null ? 'Todas' : bPartner.Currency}</h5>
          <h6>Nuevo</h6>
          <h5>{bPartner.new === 'Y' ? 'Si' : 'No'}</h5>
          <h6>Tipo Persona</h6>
          <h5>{bPartner.base_person_type_description}</h5>
          <h6>Fecha de alta</h6>
          <h5>{bPartner.start_date}</h5>
          <h6>Fecha de baja</h6>
          <h5>{bPartner.end_date}</h5>
          <h6>Acreedor transportista</h6>
          <h5>{bPartner.U_SYP_BPAT === 'Y' ? 'Si' : bPartner.U_SYP_BPAT === 'N' ? 'No' : '-'}</h5>
          <h6>Sujeto a retención / detracción</h6>
          <h5>{bPartner.WTLiable === 'Y' ? 'Si' : bPartner.WTLiable === 'N' ? 'No' : '-'}</h5>
          <h6>Estado</h6>
          <h5>
            {bPartner.frozenFor === 'N' ? (
              <Chip
                size="small"
                style={{ backgroundColor: 'green', color: 'white' }}
                label="Activo"
              />
            ) : bPartner.frozenFor === 'Y' ? (
              <Chip
                size="small"
                style={{ backgroundColor: 'red', color: 'white' }}
                label="Inactivo"
              />
            ) : (
              <Chip
                size="small"
                style={{ backgroundColor: '#878282', color: 'white' }}
                label="Sin estado"
              />
            )}
            <RegularButton justIcon color="warning" round size="sm" onClick={setFrozenForOpen}>
              <Book />
            </RegularButton>
          </h5>
          {bPartner.CardType === 'C' ? undefined : (
            <>
              <h6>Evaluación cód. compras</h6>
              <h5>
                {bPartner.item_frgn === '1'
                  ? 'Código externo 1'
                  : bPartner.item_frgn === '2'
                  ? 'Código externo 2'
                  : 'Ninguno'}
              </h5>
            </>
          )}
          <h6>Comentario</h6>
          <h5>{bPartner.Free_Text || '-'}</h5>
        </Paper>
      </GridItem>

      {bPartner.CardType === 'P' ||
        (bPartner.QryGroup1 === 'Y' && (
          <GridItem xs={12} sm={6} md={6} lg={4}>
            <h4>Compras</h4>
            <Paper className={classes.paper}>
              <h6>No considerar bonificaciónes en último precio compra</h6>
              <h5>{bPartner.QryGroup6 === 'Y' ? 'Si' : 'No'}</h5>
            </Paper>

            <h4>Promociones</h4>

            <Paper className={classes.paper}>
              <h6>Validación de bonifcaciones</h6>
              <h5>
                {bPartner.prom_bonification_validation === null
                  ? 'No'
                  : `${bPartner.prom_bonification_validation}%`}
              </h5>
            </Paper>

            <h4>Precio Mayorista</h4>
            <Paper className={classes.paper}>
              <h6>Bloqueo de precio mayorista por portafolio</h6>
              <h5>{bPartner.QryGroup10 === 'Y' ? 'Si' : 'No'}</h5>
            </Paper>
          </GridItem>
        ))}
      <GridItem xs={12}>
        <GridContainer>
          <GridItem xs={3}>
            <h6>Fecha de creación</h6>
            <p>{formatDate(bPartner.created_at)}</p>
          </GridItem>
          <GridItem xs={3}>
            <h6>Fecha de modificación</h6>
            <p>{formatDate(bPartner.updated_at)}</p>
          </GridItem>
          <GridItem xs={4}>
            <h6>Usuario que Modifica</h6>
            <p>{bPartner?.updated_by_user?.name || '--'}</p>
          </GridItem>
          <GridItem xs={2}>
            <RegularButton onClick={setOpen} color="warning">
              Ver logs
            </RegularButton>
          </GridItem>
        </GridContainer>
      </GridItem>
    </GridContainer>
  );
}
